module.exports = __webpack_public_path__ + "img/favicon.151db5fb.svg";